import type { BookableResource } from '../../checkout/resourceSelection/redux/types';

export function isResourceBookable(resource: BookableResource): boolean {
    return resource.bookable;
}
